import { css } from '@linaria/core';
import React from 'react';
import Media from './Media';
import { cx } from '@linaria/core';
function checkForDefaultValues(prop) {
    return prop === 0 ? '0' : prop === 1 ? '4px' : prop === 2 ? '8px' : prop;
}
export const localVars = {
    '--local-padding-xs': '6px',
    '--local-padding-xs-negative': '-6px',
    '--local-padding-s': '8px',
    '--local-padding-s-negative': '-8px',
    '--local-padding-m': '12px',
    '--local-padding-m-negative': '-12px',
};
export const RowRoot = {
    base: css `
		${localVars};
		display: flex;
		flex-wrap: wrap;

		box-sizing: border-box;
		width: 100%;
		margin-top: var(--local-padding-xs);
		margin-bottom: var(--local-padding-xs);
		padding-right: 0;
		padding-left: 0;

		${Media('min', 'l')} {
			margin-top: var(--local-padding-s);
			margin-bottom: var(--local-padding-s);
		}

		${Media('min', 'xl')} {
			margin-top: var(--local-padding-m);
			margin-bottom: var(--local-padding-m);
		}
	`,
    outerSpace: {
        none: css `
			width: auto;
			margin-right: var(--local-padding-xs-negative);
			margin-left: var(--local-padding-xs-negative);
			padding-right: 0;
			padding-left: 0;

			${Media('min', 'l')} {
				margin-right: var(--local-padding-s-negative);
				margin-left: var(--local-padding-s-negative);
			}

			${Media('min', 'xl')} {
				margin-right: var(--local-padding-m-negative);
				margin-left: var(--local-padding-m-negative);
			}
		`,
        even: css `
			margin-right: 0;
			margin-left: 0;
			padding-right: var(--local-padding-xs);
			padding-left: var(--local-padding-xs);

			${Media('min', 'l')} {
				padding-right: var(--local-padding-s-negative);
				padding-left: var(--local-padding-s-negative);
			}

			${Media('min', 'xl')} {
				padding-right: var(--local-padding-m-negative);
				padding-left: var(--local-padding-m-negative);
			}
		`,
        wide: css `
			margin-right: 0;
			margin-left: 0;
			padding-right: var(--layoutGrid-margin-right);
			padding-left: var(--layoutGrid-margin-left);
		`,
    },
};
export function Row({ children, outerSpace, pt, pb, pl, pr, py, px, p, mt, mb, ml, mr, my, mx, margin, alignItems, justifyContent, flexDirection, className, htmlAttributes, }) {
    pt = checkForDefaultValues(pt);
    pb = checkForDefaultValues(pb);
    pl = checkForDefaultValues(pl);
    pr = checkForDefaultValues(pr);
    px = checkForDefaultValues(px);
    py = checkForDefaultValues(py);
    p = checkForDefaultValues(p);
    mt = checkForDefaultValues(mt);
    mb = checkForDefaultValues(mb);
    ml = checkForDefaultValues(ml);
    mr = checkForDefaultValues(mr);
    mx = checkForDefaultValues(mx);
    my = checkForDefaultValues(my);
    margin = checkForDefaultValues(margin);
    return (React.createElement("div", { className: cx(RowRoot.base, RowRoot.outerSpace[outerSpace], className), style: {
            paddingTop: pt || py || p,
            paddingBottom: pb || py || p,
            paddingLeft: pl || px || p,
            paddingRight: pr || px || p,
            marginTop: mt || my || margin,
            marginBottom: mb || my || margin,
            marginLeft: ml || mx || margin,
            marginRight: mr || mx || margin,
            alignItems: alignItems,
            justifyContent: justifyContent,
            flexDirection: flexDirection,
        }, ...htmlAttributes }, children));
}
export const ColumnRoot = {
    base: css `
		${localVars};
		box-sizing: border-box;
		width: 100%;
		padding: var(--local-padding-xs);

		${Media('min', 'l')} {
			padding: var(--local-padding-s);
		}

		${Media('min', 'xl')} {
			padding: var(--local-padding-m);
		}
	`,
    breakpoints: {
        all: {
            0: css `
				display: none;
			`,
            1: css `
				width: var(--global-grid-1-12);
			`,
            2: css `
				width: var(--global-grid-2-12);
			`,
            2.4: css `
				width: var(--global-grid-2_4-12);
			`,
            3: css `
				width: var(--global-grid-3-12);
			`,
            4: css `
				width: var(--global-grid-4-12);
			`,
            5: css `
				width: var(--global-grid-5-12);
			`,
            6: css `
				width: var(--global-grid-6-12);
			`,
            7: css `
				width: var(--global-grid-7-12);
			`,
            8: css `
				width: var(--global-grid-8-12);
			`,
            9: css `
				width: var(--global-grid-9-12);
			`,
            10: css `
				width: var(--global-grid-10-12);
			`,
            11: css `
				width: var(--global-grid-11-12);
			`,
            12: css `
				width: var(--global-grid-12-12);
			`,
        },
        xs: {
            0: css `
				${Media('min', 'xs')} {
					display: none;
				}
			`,
            1: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-1-12);
				}
			`,
            2: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-2-12);
				}
			`,
            2.4: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-2_4-12);
				}
			`,
            3: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-3-12);
				}
			`,
            4: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-4-12);
				}
			`,
            5: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-5-12);
				}
			`,
            6: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-6-12);
				}
			`,
            7: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-7-12);
				}
			`,
            8: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-8-12);
				}
			`,
            9: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-9-12);
				}
			`,
            10: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-10-12);
				}
			`,
            11: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-11-12);
				}
			`,
            12: css `
				${Media('min', 'xs')} {
					display: unset;
					width: var(--global-grid-12-12);
				}
			`,
        },
        s: {
            0: css `
				${Media('min', 's')} {
					display: none;
				}
			`,
            1: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-1-12);
				}
			`,
            2: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-2-12);
				}
			`,
            2.4: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-2_4-12);
				}
			`,
            3: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-3-12);
				}
			`,
            4: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-4-12);
				}
			`,
            5: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-5-12);
				}
			`,
            6: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-6-12);
				}
			`,
            7: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-7-12);
				}
			`,
            8: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-8-12);
				}
			`,
            9: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-9-12);
				}
			`,
            10: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-10-12);
				}
			`,
            11: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-11-12);
				}
			`,
            12: css `
				${Media('min', 's')} {
					display: unset;
					width: var(--global-grid-12-12);
				}
			`,
        },
        m: {
            0: css `
				${Media('min', 'm')} {
					display: none;
				}
			`,
            1: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-1-12);
				}
			`,
            2: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-2-12);
				}
			`,
            2.4: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-2_4-12);
				}
			`,
            3: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-3-12);
				}
			`,
            4: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-4-12);
				}
			`,
            5: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-5-12);
				}
			`,
            6: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-6-12);
				}
			`,
            7: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-7-12);
				}
			`,
            8: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-8-12);
				}
			`,
            9: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-9-12);
				}
			`,
            10: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-10-12);
				}
			`,
            11: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-11-12);
				}
			`,
            12: css `
				${Media('min', 'm')} {
					display: unset;
					width: var(--global-grid-12-12);
				}
			`,
        },
        l: {
            0: css `
				${Media('min', 'l')} {
					display: none;
				}
			`,
            1: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-1-12);
				}
			`,
            2: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-2-12);
				}
			`,
            2.4: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-2_4-12);
				}
			`,
            3: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-3-12);
				}
			`,
            4: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-4-12);
				}
			`,
            5: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-5-12);
				}
			`,
            6: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-6-12);
				}
			`,
            7: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-7-12);
				}
			`,
            8: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-8-12);
				}
			`,
            9: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-9-12);
				}
			`,
            10: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-10-12);
				}
			`,
            11: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-11-12);
				}
			`,
            12: css `
				${Media('min', 'l')} {
					display: unset;
					width: var(--global-grid-12-12);
				}
			`,
        },
        xl: {
            0: css `
				${Media('min', 'xl')} {
					display: none;
				}
			`,
            1: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-1-12);
				}
			`,
            2: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-2-12);
				}
			`,
            2.4: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-2_4-12);
				}
			`,
            3: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-3-12);
				}
			`,
            4: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-4-12);
				}
			`,
            5: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-5-12);
				}
			`,
            6: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-6-12);
				}
			`,
            7: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-7-12);
				}
			`,
            8: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-8-12);
				}
			`,
            9: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-9-12);
				}
			`,
            10: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-10-12);
				}
			`,
            11: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-11-12);
				}
			`,
            12: css `
				${Media('min', 'xl')} {
					display: unset;
					width: var(--global-grid-12-12);
				}
			`,
        },
        xxl: {
            0: css `
				${Media('min', 'xxl')} {
					display: none;
				}
			`,
            1: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-1-12);
				}
			`,
            2: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-2-12);
				}
			`,
            2.4: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-2_4-12);
				}
			`,
            3: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-3-12);
				}
			`,
            4: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-4-12);
				}
			`,
            5: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-5-12);
				}
			`,
            6: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-6-12);
				}
			`,
            7: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-7-12);
				}
			`,
            8: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-8-12);
				}
			`,
            9: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-9-12);
				}
			`,
            10: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-10-12);
				}
			`,
            11: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-11-12);
				}
			`,
            12: css `
				${Media('min', 'xxl')} {
					display: unset;
					width: var(--global-grid-12-12);
				}
			`,
        },
    },
};
export function Column({ children, all, xs, s, m, l, xl, xxl, pt, pb, pl, pr, py, px, p, mt, mb, ml, mr, my, mx, margin, className, htmlAttributes, }) {
    pt = checkForDefaultValues(pt);
    pb = checkForDefaultValues(pb);
    pl = checkForDefaultValues(pl);
    pr = checkForDefaultValues(pr);
    px = checkForDefaultValues(px);
    py = checkForDefaultValues(py);
    p = checkForDefaultValues(p);
    mt = checkForDefaultValues(mt);
    mb = checkForDefaultValues(mb);
    ml = checkForDefaultValues(ml);
    mr = checkForDefaultValues(mr);
    mx = checkForDefaultValues(mx);
    my = checkForDefaultValues(my);
    margin = checkForDefaultValues(margin);
    return (React.createElement("div", { className: cx(ColumnRoot.base, (all || all === 0) && ColumnRoot.breakpoints.all[all], (xs || xs === 0) && ColumnRoot.breakpoints.xs[xs], (s || s === 0) && ColumnRoot.breakpoints.s[s], (m || m === 0) && ColumnRoot.breakpoints.m[m], (l || l === 0) && ColumnRoot.breakpoints.l[l], (xl || xl === 0) && ColumnRoot.breakpoints.xl[xl], (xxl || xxl === 0) && ColumnRoot.breakpoints.xxl[xxl], className), style: {
            paddingTop: pt || py || p,
            paddingBottom: pb || py || p,
            paddingLeft: pl || px || p,
            paddingRight: pr || px || p,
            marginTop: mt || my || margin,
            marginBottom: mb || my || margin,
            marginLeft: ml || mx || margin,
            marginRight: mr || mx || margin,
        }, ...htmlAttributes }, children));
}
export const MainBox = {
    base: css `
		box-sizing: border-box;
		padding-right: var(--layoutGrid-margin-right);
		padding-left: var(--layoutGrid-margin-left);
	`,
};
export const FullwidthBox = {
    base: css `
		width: auto;
		margin-right: calc(-1 * var(--layoutGrid-margin-right));
		margin-left: calc(-1 * var(--layoutGrid-margin-left));
	`,
};
